import { z } from 'zod';
import { vehicleQuantityAndTypeSchema } from '../../common';
import { quantitySchema } from '../../validation';

/**
 * @deprecated Part of the legacy `Business` collection. The unified
 * `Org` collection captures volume expectations via onboarding metadata
 * instead. See `BusinessSchema` for the full deprecation note.
 */
export const businessOrdersSchema = z.object({
  expectedMonthlyOrders: quantitySchema,
  monthlyOrdersByVehicleType: z.array(vehicleQuantityAndTypeSchema).min(1),
});
